<template>
  <h1 class="title" :class="{ isPc: !isSp, wideSp: wideSp }">{{ text }}</h1>
</template>

<script>
export default {
  name: 'Complete',
  props: {
    text: {
      type: String,
      required: true,
    },
    wideSp: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.title {
  font-size: $text-size-sp-h4;
  line-height: $text-line-height-little;
  margin-bottom: 16px;
  font-weight: $text-weight-bold;

  &.wideSp {
    margin-bottom: 24px;
  }

  &.isPc {
    text-align: center;
    font-size: $text-size-pc-h4;
    margin-bottom: 32px;
  }
}
</style>
